<template>
  <div class="user-profile-container">
    <!-- 头部信息 -->
    <div class="profile-header">
      <div class="cover-photo"></div>
      <div class="avatar-section">
        <div class="avatar-wrapper">
          <el-avatar :size="120" :src="`${userInfo.avatar}`" />
          <el-upload
            v-if="editable"
            class="avatar-uploader"
            :action="action"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
          >
            <el-button type="primary" circle class="upload-btn">
              <el-icon>
                <Camera />
              </el-icon>
            </el-button>
          </el-upload>
        </div>
        <h2 class="username">{{ userInfo.nickName || userInfo.username }}</h2>
        <p class="user-id">用户ID: {{ userInfo.uid }}</p>
      </div>
    </div>
    <!-- 主要内容 -->
    <div class="profile-content">
      <el-tabs v-model="activeTab" class="profile-tabs">
        <!-- 基本信息标签页 -->
        <el-tab-pane label="基本信息" name="basic">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="用户ID">{{ userInfo.uid }}</el-descriptions-item>
            <el-descriptions-item label="昵称">
              <span v-if="!editing.nickName">{{ userInfo.nickName }}</span>
              <el-input v-else v-model="editForm.nickName" size="small" style="width: 200px" />
              <el-button
                v-if="editable && !editing.nickName"
                text
                size="small"
                @click="startEditing('nickName')"
              >
                <el-icon>
                  <Edit />
                </el-icon>
              </el-button>
              <div v-if="editing.nickName" class="edit-actions">
                <el-button text size="small" @click="saveEdit('nickName')">
                  <el-icon>
                    <Check />
                  </el-icon>
                </el-button>
                <el-button text size="small" @click="cancelEdit('nickName')">
                  <el-icon>
                    <Close />
                  </el-icon>
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="用户名">{{ userInfo.userName }}</el-descriptions-item>
            <el-descriptions-item label="部门">{{ getDeptName(userInfo.deptId) }}</el-descriptions-item>
            <el-descriptions-item label="角色">{{ userInfo.roleNames }}</el-descriptions-item>
            <el-descriptions-item label="性别">
              <span v-if="!editing.sex">
                {{ userInfo.sex =='0'?'男':userInfo.sex =='1'
                ?'女':'未知'}}
              </span>
              <el-radio-group v-else v-model="editForm.sex" class="ml-4">
                <el-radio label="0" size="small">男</el-radio>
                <el-radio label="1" size="small">女</el-radio>
                <el-radio label="2" size="small">未知</el-radio>
              </el-radio-group>
              <el-button
                v-if="editable && !editing.sex"
                text
                size="small"
                @click="startEditing('sex')"
              >
                <el-icon>
                  <Edit />
                </el-icon>
              </el-button>
              <div v-if="editing.sex" class="edit-actions">
                <el-button text size="small" @click="saveEdit('sex')">
                  <el-icon>
                    <Check />
                  </el-icon>
                </el-button>
                <el-button text size="small" @click="cancelEdit('sex')">
                  <el-icon>
                    <Close />
                  </el-icon>
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">
              <span v-if="!editing.email">{{ userInfo.email || '未设置' }}</span>
              <el-input v-else v-model="editForm.email" size="small" style="width: 200px" />
              <el-button
                v-if="editable && !editing.email"
                text
                size="small"
                @click="startEditing('email')"
              >
                <el-icon>
                  <Edit />
                </el-icon>
              </el-button>
              <div v-if="editing.email" class="edit-actions">
                <el-button text size="small" @click="saveEdit('email')">
                  <el-icon>
                    <Check />
                  </el-icon>
                </el-button>
                <el-button text size="small" @click="cancelEdit('email')">
                  <el-icon>
                    <Close />
                  </el-icon>
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="手机号">
              <span v-if="!editing.phoneNumber">{{ userInfo.phoneNumber || '未设置' }}</span>
              <el-input v-else v-model="editForm.phoneNumber" size="small" style="width: 200px" />
              <el-button
                v-if="editable && !editing.phoneNumber"
                text
                size="small"
                @click="startEditing('phoneNumber')"
              >
                <el-icon>
                  <Edit />
                </el-icon>
              </el-button>
              <div v-if="editing.phoneNumber" class="edit-actions">
                <el-button text size="small" @click="saveEdit('phoneNumber')">
                  <el-icon>
                    <Check />
                  </el-icon>
                </el-button>
                <el-button text size="small" @click="cancelEdit('phoneNumber')">
                  <el-icon>
                    <Close />
                  </el-icon>
                </el-button>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>

        <!-- 安全设置标签页 -->
        <el-tab-pane label="安全设置" name="security" v-if="editable">
          <div class="security-section">
            <el-form
              :model="passwordForm"
              :rules="passwordRules"
              ref="passwordFormRef"
              label-width="100px"
            >
              <el-form-item label="当前密码" prop="currentPassword">
                <el-input v-model="passwordForm.currentPassword" type="password" show-password></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="passwordForm.newPassword" type="password" show-password></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input v-model="passwordForm.confirmPassword" type="password" show-password></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="changePassword">修改密码</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="edit-buttons" v-if="activeTab=='basic'">
        <el-button v-show="!editable" type="primary" size="small" @click="editable=!editable">编辑</el-button>
        <el-button v-show="editable" type="success" size="small" @click="saveInfo">保存</el-button>
        <el-button v-show="editable" size="small" @click="editable=!editable">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, defineProps, watch } from "vue";
import { ElMessage } from "element-plus";
import request from "@/utils/request.ts";
import { getToken, getTenant, getImageUrl } from "@/utils/auth";
import API_CONFIG from "../api.json";
import comCueBox from "@/components/comCue/comCue";

const emit = defineEmits(["update-user", "update-avatar", "update-password", "close-pannel"]);
const props = defineProps(["user"]);
// 数据状态

const headers = computed(() => ({
  Authorization: getToken(), // 从store获取token
  Tenant:getTenant(),
  "X-Requested-With": "XMLHttpRequest"
}));
const activeTab = ref("basic");
const editable = ref(false);
const userInfo = ref({});
const action = API_CONFIG.uploadImg.url;

watch(
  () => props.user,
  tmpInfo => {
    userInfo.value = { ...tmpInfo };
  },
  { deep: true, immediate: true }
);
const editForm = reactive({
  nickName: "",
  email: "",
  phoneNumber: "",
  sex: ""
});

const editing = reactive({
  nickName: false,
  email: false,
  phoneNumber: false,
  sex: false
});

const passwordForm = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: ""
});

// 密码验证规则
const validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else if (value.length < 6) {
    callback(new Error("密码长度不能少于6位"));
  } else {
    if (passwordForm.confirmPassword !== "") {
      passwordFormRef.value.validateField("confirmPassword");
    }
    callback();
  }
};

const validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请再次输入密码"));
  } else if (value !== passwordForm.newPassword) {
    callback(new Error("两次输入密码不一致!"));
  } else {
    callback();
  }
};

const passwordRules = reactive({
  currentPassword: [
    { required: true, message: "请输入当前密码", trigger: "blur" }
  ],
  newPassword: [ { required: true, message: "请输入密码", trigger: "blur" },{ validator: validatePass, trigger: "blur" }],
  confirmPassword: [ { required: true, message: "请输入密码", trigger: "blur" },{ validator: validatePass2, trigger: "blur" }]
});

const passwordFormRef = ref();

// 计算属性
const getDeptName = computed(() => deptId => {
  const dept = {};
  return dept ? dept.name : "未知部门";
});

// 方法
const formatDate = dateString => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString();
};

const startEditing = field => {
  editForm[field] = userInfo.value[field];
  editing[field] = true;
};

const cancelEdit = field => {
  editing[field] = false;
};

const saveEdit = field => {
  userInfo.value[field] = editForm[field];
  editing[field] = false;
};

const saveInfo = () => {
  request.post(API_CONFIG.updateSysUser.url, userInfo.value).then(res => {
    if (res.code == 200) {
      ElMessage.success("修改成功");
      editable.value = false;
      emit("update-user", userInfo.value);
    } else {
      ElMessage.error("修改失败");
    }
  });
};

const handleSuccess = (response, file) => {
  if (response.code === 200) {
    // emit("update:modelValue", window.origin + "/static/" + response.data);
    userInfo.value["avatar"] = getImageUrl(response.data)
  } else {
    ElMessage.error("文件导入失败");
  }
};

const handleError = err => {
  console.error("上传失败:", err);
  error.value = "文件上传失败，请重试";
};

const beforeAvatarUpload = file => {
  const isImage = file.type.startsWith("image/");
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("只能上传图片文件!");
  }
  if (!isLt2M) {
    ElMessage.error("图片大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleAvatarUpload = async ({ file }) => {
  try {
    // 这里应该是上传头像的API调用
    // const formData = new FormData()
    // formData.append('file', file)
    // const { data } = await uploadAvatar(formData)

    // 模拟上传成功
    const avatarUrl = URL.createObjectURL(file);
    userInfo.value.avatar = avatarUrl;
    emit("update-avatar", avatarUrl);
    ElMessage.success("头像上传成功");
  } catch (error) {
    ElMessage.error("头像上传失败");
  }
};

const changePassword = () => {
  passwordFormRef.value.validate(valid => {
    if (valid) {
      comCueBox("确定要修改密码吗?").then(() => {
        updatePassword();
      });
    }
  });
};

const updatePassword = () => {
  request
    .post(API_CONFIG.updateUserPassword.url, {
      password: passwordForm.newPassword,
      id: userInfo.value.id
    })
    .then(res => {
      if (res.code == 200) {
        ElMessage.success("修改成功");
        emit("close-pannel");
      } else {
        ElMessage.error("修改失败");
      }
    });
};
</script>

<style scoped>
.user-profile-container {
  max-width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-header {
  position: relative;
  margin-bottom: 50px;
}

.cover-photo {
  height: 180px;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  background-size: cover;
  background-position: center;
}

.avatar-section {
  text-align: center;
  margin-top: -60px;
  padding-bottom: 20px;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
}

.upload-btn {
  position: absolute;
  right: 0;
  bottom: 0;
}

.username {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.user-id {
  margin: 5px 0 0;
  font-size: 14px;
  color: #888;
}

.profile-content {
  padding: 0 20px 20px;
  position: relative;
}
.edit-buttons {
  position: absolute;
  top: 10px;
  right: 20px;
}

.profile-tabs {
  margin-top: 20px;
}

.edit-actions {
  display: inline-block;
  margin-left: 10px;
}

.security-section {
  padding: 20px;
  max-width: 500px;
}

:deep(.el-descriptions__body) {
  background-color: #fff;
}

:deep(.el-descriptions__label) {
  width: 100px;
}
</style>